<template lang="pug">
  .multiple-row-action
    .selection
      label.select-all-cb.checkbox-wrapper
        input(type="checkbox" :checked="selectionCount" @input="toggleSelectAll")
        .checkbox-indicator
      .selection-count(v-if="selectionCount") Sélection multiple ({{ selectionCount }} {{ unit }})
    .actions(v-if="selectionCount")
      .action(v-for="action in actions" :key="action.event")
        button(@click="triggerAction(action)") {{ getActionLabel(action.label) }}
</template>

<script>
export default {
  props: {
    selectionCount: {
      type: Number,
      required: true,
    },
    actions: {
      type: Array,
      default: () => [],
    },
    units: {
      type: Object,
      default: () => { return { singular: 'ligne', plural: 'lignes' }; },
    }
  },
  methods: {
    getActionLabel(label) {
      return label
        .replace('$count', `${this.selectionCount}`)
        .replace('$unit', `${this.unit}`);
    },
    triggerAction(action) {
      this.$emit(action.event);
    },
    toggleSelectAll(e) {
      this.$emit(e.target.checked ? 'selectAll' : 'deselectAll');
    },
  },
  computed: {
    unit() {
      return this.selectionCount === 1 ? this.units.singular : this.units.plural;
    },
  },
}
</script>

<style lang="scss">
  .multiple-row-action {
    height: 60px;
    display: flex;
    align-items: center;
    background: #FAFAFA;
    border-top: 2px solid #DDDDDD;
    justify-content: space-between;
    .selection {
      display: flex;
      align-items: center;
    }
    .select-all-cb {
      margin-left: 1.5em;
    }
    .selection-count, .action {
      margin: 0 24px;
    }
    .selection-count {
      font-size: 18px;
      color: #ADADAD;
    }
  }
</style>